module.exports = __webpack_public_path__ + "static/media/shortfinsoftware_stacked_white_nobg.3a23a103.png";